import Markdown from 'markdown-to-jsx';
import { FC, memo } from 'react';

import styles from './index.module.scss';
import contents from './termOfUseForBpoKihyo.md?raw';

const options = {
  overrides: {
    h2: { props: { className: styles['text-heading__primary'] } },
    h3: { props: { className: styles['text-heading__secondary'] } },
    h4: { props: { className: styles['text-heading__tertiary'] } },
    a: {
      props: {
        className: styles['text-link'],
        target: '_blank',
        rel: 'noopener',
      },
    },
    ul: { props: { className: styles.list } },
  },
};

export const TermOfUseAgentBpoReceives: FC = memo(() => {
  return (
    <div className={styles.container}>
      <Markdown options={options}>{contents}</Markdown>
    </div>
  );
});

TermOfUseAgentBpoReceives.displayName = 'TermOfUseAgentBpoReceives';
